export const serializeTemplate = template => ({
  label: template.subject,
  reason: String(template.reason_id),
  mailGroup: String(template.mail_group_id),
  notificationChannel: String(template.notification_channel),
  notificationMessage: String(template.notification_message),
  value: String(template.id),
});

export const serializeTemplates = templates => {
  if (!templates || templates.length <= 0) return [];

  return templates.map(template => serializeTemplate(template));
};

export const serializeTaskTemplate = template => ({
  id: String(template.id),
  label: template.name,
  summary: template.summary,
  description: template.description,
  priority: template.priority,
  skillGroupId: String(template.skill_group_id),
});

export const serializeTaskTemplates = templates => {
  if (!templates || templates.length <= 0) return [];

  return templates.map(template => serializeTaskTemplate(template));
};
